// Ouverture de l'accueil ROK : repères des cinq actifs autour du pot (photo Vitrail argenté, animée en CSS).
const hero = document.querySelector('.rok-hh');
if (hero) {
  const side = hero.querySelector('[data-hh-side]'), win = hero.querySelector('[data-hh-win]');
  const calls = hero.querySelector('[data-hh-calls]');
  const doses = [...hero.querySelectorAll('[data-hh-doses] li')].map(li => ({
    s: li.dataset.side, y: +li.dataset.y, n: li.querySelector('strong').innerHTML, k: li.querySelector(':scope > span').textContent, a: li.dataset.act
  }));
  let drawn = false;

  // Repères : point sur le pot, oblique de même angle pour tous, palier jusqu'à une colonne commune par côté
  function placeDoses(p, tagL, tagR) {
    // Largeur utile sans la barre de défilement
    const vw = document.documentElement.clientWidth, small = vw <= 900, sr = side.getBoundingClientRect();
    const rise = small ? 22 : 34, run = small ? 14 : 22, edge = small ? 14 : 96;
    // Largeur réelle des doses (mesurée au premier passage), sinon estimation
    const wL = tagL || (small ? 92 : 190), wR = tagR || (small ? 92 : 190);
    const bw = p.r - p.l;
    let colL = p.l - Math.max(small ? 40 : 90, bw * .42), colR = p.r + Math.max(small ? 40 : 90, bw * .42);
    colL = Math.max(colL, edge + wL - sr.left); colR = Math.min(colR, vw - edge - wR - sr.left);
    let svg = '', tags = '';
    doses.forEach((d, i) => {
      const left = d.s === 'l', x0 = left ? p.l + bw * .14 : p.r - bw * .14, y0 = p.t + (p.b - p.t) * d.y;
      const x1 = x0 + (left ? -run : run), y1 = y0 - rise;
      const x2 = left ? Math.min(colL, x1 - 10) : Math.max(colR, x1 + 10);
      const len = Math.round(Math.hypot(run, rise) + Math.abs(x2 - x1));
      const st = `--d:${drawn ? 0 : .35 + i * .14}s;--len:${len}`;
      svg += `<path style="${st}" d="M${x0} ${y0} L${x1} ${y1} L${x2} ${y1}"/><circle class="h" style="${st}" cx="${x0}" cy="${y0}" r="8"/><circle class="c" style="${st}" cx="${x0}" cy="${y0}" r="4.5"/>`;
      const pos = left ? `right:${sr.width - x2}px` : `left:${x2}px`;
      tags += `<div class="rok-hh-tag ${d.s}" style="${st};top:${y1}px;${pos}" aria-hidden="true"><strong>${d.n}</strong><span class="k">${d.k}</span></div>`;
    });
    calls.innerHTML = `<svg aria-hidden="true">${svg}</svg>${tags}`;
    hero.classList.add('is-placed');
    // Second passage avec les largeurs mesurées, mêmes délais d'animation
    if (!tagL) {
      const max = side => Math.max(0, ...[...calls.querySelectorAll('.rok-hh-tag.' + side)].map(e => e.offsetWidth));
      const ml = max('l'), mr = max('r');
      if (ml && mr) placeDoses(p, ml, mr);
    }
    drawn = true;
  }
  // Rectangle du pot (photo, hauteur 84 % de la fenêtre, posé à 7 % du bas), en coordonnées de la colonne
  function potRect() {
    const r = win.getBoundingClientRect(), s = side.getBoundingClientRect();
    const h = r.height * .84, w = h * 791 / 1306, cx = r.left - s.left + r.width / 2, bot = r.top - s.top + r.height * .93;
    return {l: cx - w / 2, r: cx + w / 2, t: bot - h, b: bot};
  }
  // Ajuste un texte d'une ligne (ou du mot sur deux lignes) à la largeur disponible, sans dépasser sa taille CSS
  function fit(el, maxW) {
    if (!el) return;
    el.style.fontSize = '';
    const w = el.scrollWidth, base = parseFloat(getComputedStyle(el).fontSize);
    if (w > maxW) el.style.fontSize = Math.floor(base * maxW / w) + 'px';
  }
  const word = hero.querySelector('.rok-hh-word'), title = hero.querySelector('.rok-hh-title');
  function fitTexts() {
    const vw = document.documentElement.clientWidth, small = vw <= 900;
    const wl = word.getBoundingClientRect().left - hero.getBoundingClientRect().left;
    // Ordinateur : le mot s'arrête avant la colonne du pot ; mobile : marge de 16 px de chaque côté
    fit(word.firstElementChild, small ? vw - wl - 16 : side.getBoundingClientRect().left - hero.getBoundingClientRect().left - wl - 24);
    fit(title, small ? vw - 32 : side.clientWidth);
  }
  const relayout = () => { fitTexts(); placeDoses(potRect()); };
  new ResizeObserver(relayout).observe(side);
  relayout();
  document.fonts?.ready.then(relayout);
}
